import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosBitrixInstance } from "@/resources/requestInfo";
import { IProduct } from "./types";

export const getProducts = createAsyncThunk<IProduct[]>(
  "products/getProducts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosBitrixInstance.get(`/ProductsForSale/`);
      return response.data.productForSale;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

